import React from "react";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";
import { Panel } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";
import { toggleDriversPanel } from "../../../config/redux/drivers/driversActions";
import { panelS } from "../../common/styles/panelStyles"
import DriverForm from "./DriverForm";

const DriverPanel: React.SFC = () => {
  const { t } = useTranslation("admin");
  const dispatch = useDispatch();
  const { driverPanelOpen } = useSelector(
    (state: RootStateOrAny) => state.drivers
  );

  const dissmisPanel = () => {
    dispatch(toggleDriversPanel({ open: false }));
  };

  return (
    <Panel
      headerText={t("nav.panelDriver") as string}
      isOpen={driverPanelOpen}
      closeButtonAriaLabel={t("nav.close") as string}
      type={1}
      onDismiss={dissmisPanel}
      isLightDismiss={false}
      isHiddenOnDismiss={false}
      styles={panelS}
    >
      <DriverForm />
    </Panel>
  );
};

export default DriverPanel;